import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { CreateRollNumberComponent } from "../../components/roll-number/create-roll-number/create-roll-number.component";
import { DeleteRollNumberComponent } from "../../components/roll-number/delete-roll-number/delete-roll-number.component";
import { RollNumberConfigService } from '../../services/roll-number-config.service';
import { AcademicYearService } from '../../services/acedemicyear.service';

@Component({
  selector: 'app-roll-number-configuration',
  imports: [SharedModule, ToolBarComponent, CreateRollNumberComponent, DeleteRollNumberComponent],
  templateUrl: './roll-number-configuration.component.html',
  styleUrl: './roll-number-configuration.component.scss'
})
export class RollNumberConfigurationComponent {
  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 10;
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  isAddRollNumberConfig: boolean = false;
  isEditRollNumberConfig: boolean = false;
  isDeleteRollNumberConfig: boolean = false;
  rollNumberConfigData: any;

  columns: any[] = [
    { field: 'department.name', header: 'Department', sortable: true },
    { field: 'academic_year.year', header: 'Academic Year', sortable: true },
    { field: 'prefix', header: 'Prefix', sortable: true },
    { field: 'counter', header: 'Counter', sortable: true },
    { field: 'length', header: 'Length', sortable: true },
    { field: 'actions', header: 'Actions', type: 'actions' }
  ];

  allDepartments: any[] = [];
  allAcademicYears: any[] = [];

  rollNumberConfigActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Roll Number Config',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditRollNumberConfig = true;
          }
        },
        {
          label: 'Delete Roll Number Config',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteRollNumberConfig = true;
          }
        }
      ]
    }
  ];

  constructor(
    private api: RollNumberConfigService,
    private academicYearService: AcademicYearService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.loadData({ first: 0, rows: this.rows });
    this.getAllDepartments();
    this.getAllAcademicYears();
  }

  getAllDepartments() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.api.getAllDepartments(param).subscribe({
      next: (res: any) => {
        this.allDepartments = res || [];
        this.allDepartments = this.allDepartments.map((department: any) => {
          return {
            label: department.name,
            value: department?.dept_id
          };
        });
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  getAllAcademicYears() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.academicYearService.getAllAcademicYears(param).subscribe({
      next: (res: any) => {
        this.allAcademicYears = res || [];
        this.allAcademicYears = this.allAcademicYears.map((academicYear: any) => {
          return {
            label: academicYear.year_name,
            value: academicYear?.id
          };
        });
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  loadData(event: any) {
    const page = event.first || 0;
    const size = event.rows || this.rows;

    const param = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId()
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"roll_number_config\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    this.loading = true;

    this.api.getAllRollNumberConfigsWithCount(param).subscribe({
      next: (data) => {
        this.dataSource = data.rows || [];
        this.totalRecords = data.count || 0;
        this.loading = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load roll number configurations.' });
        this.initialLoad = false;
        this.loading = false;
      },
    });
  }

  setRollNumberConfigData(rowData: any) {
    this.rollNumberConfigData = rowData;
  }

  handleAddRollNumberConfig() {
    this.isAddRollNumberConfig = true;
  }

  reloadData() {
    this.loadData({ first: 0, rows: this.rows });
  }
}
